/* Zenivia theme scripts — small, dependency-free enhancements.
   Every feature works without JS; these only make it nicer. */
(function () {
  'use strict';

  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) return;
    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Gallery: thumbnails, prev/next arrows and swipe
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var stage = gallery.querySelector('.gallery__main');
    var main = gallery.querySelector('.gallery__main img');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!main || thumbs.length === 0) return;
    var current = 0;

    function show(index) {
      var n = thumbs.length;
      current = ((index % n) + n) % n;
      var thumb = thumbs[current];
      main.srcset = thumb.getAttribute('data-srcset') || '';
      main.src = thumb.getAttribute('data-src');
      main.alt = thumb.getAttribute('data-alt') || main.alt;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });

    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    // Swipe left/right on touch screens
    var startX = null, startY = null;
    stage.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
      startX = startY = null;
    }, { passive: true });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var autoSubmit = wrap.hasAttribute('data-qty-submit');
    function set(v) {
      var min = parseInt(input.min || '0', 10);
      var val = Math.max(min, v);
      if (val === parseInt(input.value, 10)) return;
      input.value = val;
      if (autoSubmit && input.form) input.form.submit();
    }
    wrap.querySelector('[data-qty-minus]').addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
    wrap.querySelector('[data-qty-plus]').addEventListener('click', function () { set((parseInt(input.value, 10) || 0) + 1); });
    if (autoSubmit) input.addEventListener('change', function () { input.form.submit(); });
  });

  // Variant select: update price + availability
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var scope = select.closest('[data-buybox]');
    if (!scope) return;
    var priceEl = scope.querySelector('[data-price]');
    var compareEl = scope.querySelector('[data-compare-price]');
    var addBtn = scope.querySelector('[data-add-button]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (priceEl) priceEl.textContent = opt.getAttribute('data-price');
      if (stickyPrice) stickyPrice.textContent = opt.getAttribute('data-price');
      if (compareEl) {
        var cmp = opt.getAttribute('data-compare');
        compareEl.textContent = cmp || '';
        compareEl.hidden = !cmp;
      }
      if (addBtn) {
        var available = opt.getAttribute('data-available') === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.getAttribute('data-label') : addBtn.getAttribute('data-soldout');
      }
    });
  });

  // Offer popup: before adding to cart / buy now, offer the multi-bottle discount
  var upsell = document.querySelector('[data-upsell]');
  var buyForm = document.getElementById('BuyForm');
  if (upsell && buyForm && typeof upsell.showModal === 'function') {
    var upQty = parseInt(upsell.getAttribute('data-upsell-qty'), 10) || 2;
    var upPct = parseInt(upsell.getAttribute('data-upsell-discount'), 10) || 0;
    var fmt = null;
    try { fmt = new Intl.NumberFormat('es-CL', { style: 'currency', currency: upsell.getAttribute('data-currency') || 'CLP' }); } catch (err) {}
    var variantInput = function () { return buyForm.querySelector('[name="id"]'); };
    var chosenQty = function () {
      var q = buyForm.querySelector('[name="quantity"]');
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    };
    var goToCheckout = function (q) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = root + 'cart/' + variantInput().value + ':' + q;
    };
    var updatePrices = function () {
      var input = variantInput();
      var opt = input && input.options ? input.options[input.selectedIndex] : null;
      var cents = opt ? parseInt(opt.getAttribute('data-cents'), 10) : NaN;
      if (!fmt || isNaN(cents)) return;
      var full = cents * upQty;
      var price = Math.floor(full * (100 - upPct) / 100);
      upsell.querySelector('[data-upsell-full]').textContent = fmt.format(full / 100);
      upsell.querySelector('[data-upsell-price]').textContent = fmt.format(price / 100);
      upsell.querySelector('[data-upsell-save]').textContent = fmt.format((full - price) / 100);
    };
    var offer = function (e) {
      if (chosenQty() >= upQty) return; // already buying the pack
      e.preventDefault();
      e.stopImmediatePropagation();
      updatePrices();
      upsell.showModal();
    };
    buyForm.addEventListener('submit', offer);
    var payButton = buyForm.querySelector('.shopify-payment-button, [data-shopify="payment-button"]');
    if (payButton) payButton.addEventListener('click', offer, true);
    upsell.querySelector('[data-upsell-accept]').addEventListener('click', function () { goToCheckout(upQty); });
    upsell.querySelector('[data-upsell-skip]').addEventListener('click', function () { goToCheckout(chosenQty()); });
    upsell.querySelector('[data-upsell-close]').addEventListener('click', function () { upsell.close(); });
    upsell.addEventListener('click', function (e) { if (e.target === upsell) upsell.close(); });
  }

  // Policy windows: open from any link to #politica-*, #informacion-contacto
  function openPolicyFromHash() {
    var id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;
    var dialog = document.getElementById(id);
    if (dialog && dialog.classList.contains('policy-dialog') && typeof dialog.showModal === 'function' && !dialog.open) {
      document.querySelectorAll('dialog.policy-dialog[open]').forEach(function (d) { d.close(); });
      dialog.showModal();
      dialog.scrollTop = 0;
    }
  }
  document.querySelectorAll('dialog.policy-dialog').forEach(function (dialog) {
    dialog.addEventListener('close', function () {
      if (window.location.hash === '#' + dialog.id) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close(); // click on the backdrop
    });
    var closeBtn = dialog.querySelector('[data-policy-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
  });
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#politica-"], a[href="#informacion-contacto"]');
    if (!link) return;
    var dialog = document.getElementById(link.getAttribute('href').slice(1));
    if (!dialog || typeof dialog.showModal !== 'function') return;
    e.preventDefault();
    history.pushState(null, '', link.getAttribute('href'));
    openPolicyFromHash();
  });
  window.addEventListener('hashchange', openPolicyFromHash);
  window.addEventListener('popstate', function () {
    if (!window.location.hash) document.querySelectorAll('dialog.policy-dialog[open]').forEach(function (d) { d.close(); });
    else openPolicyFromHash();
  });
  openPolicyFromHash();

  // Sticky mobile buy bar: show once the main buy form is scrolled past
  var sticky = document.querySelector('[data-sticky-buy]');
  var anchor = document.querySelector('[data-buy-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-buy');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      });
    });
    io.observe(anchor);
  }
})();
